












import Vue from 'vue'
import { mapState } from 'vuex';

export default Vue.extend({
  props: {
    side: String
  },
  data() {
    return {
      selectedUserName: ''
    }
  },
  computed: {
    ...mapState(['users'])
  },
  methods: {
    async selectUser(id: number) {
      await this.$store.dispatch('loadDeals', {
        side: this.side,
        userId: id
      })
    }
  }
})
